var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-350b4003.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-42970741.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a34.717 34.717 0 0 1-.337 5.316H.325a34.916 34.916 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a30.81 30.81 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M22.667 17.925v-7.258H9.333v7.258c0 3.341 3 6.075 6.667 6.075s6.667-2.734 6.667-6.075Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M12 10.667v2.666H9.334v-2.666H12Zm2.667 0h2.667v2.666h-2.667v-2.666Zm5.333 0h2.667v2.666H20v-2.666Zm-10.617 8a5.536 5.536 0 0 1-.05-.742V16H12v2.667H9.383Zm7.95 5.21a7.252 7.252 0 0 1-2.666 0v-2.544h2.667v2.544Zm-6.844-2.544H12v1.444a6.442 6.442 0 0 1-1.51-1.444Zm11.022 0a6.444 6.444 0 0 1-1.51 1.444v-1.444h1.51ZM22.667 16v1.925c0 .251-.017.499-.05.742H20V16h2.667ZM12 13.333h2.667V16H12v-2.667Zm5.334 0H20V16h-2.666v-2.667ZM14.667 16h2.667v2.667h-2.667V16ZM12 18.667h2.667v2.666H12v-2.666Zm5.334 0H20v2.666h-2.666v-2.666Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "m24 7.448-1.19-1.746-1.973.663-1.385-1.438-1.825.95L16 4.667l-1.627 1.21-1.825-.95-1.385 1.438-1.972-.663L8 7.448l1.333 3.219S11.62 9.453 16 9.453s6.667 1.213 6.667 1.213L24 7.448Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "m20.4 8.301 2.876.933-.259.619-2.749-.903.133-.649Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "m20.1 9.85.737-3.485-1.385-1.438-1.825.95-.304 3.614c1.089.064 2.015.2 2.776.36Zm-5.4-.36-.327-3.613-1.824-.95-1.385 1.438.863 3.46A19.209 19.209 0 0 1 14.7 9.49Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M16 8.733c.293-.002.457-.332.457-.639h-.075l.151-.269-.304.122-.229-.28-.229.28-.304-.122.152.27h-.076c0 .306.164.64.457.638Zm-.8-1.666c.293-.002.457-.332.457-.64h-.075l.151-.268-.305.121L15.2 6l-.229.28-.305-.121.153.268h-.076c0 .308.164.642.457.64Zm1.6 0c.293-.002.457-.332.457-.64h-.075l.151-.268-.304.121-.23-.28-.228.28-.304-.121.152.268h-.076c0 .308.164.642.457.64Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M18.465 6.86c.048-.055.052-.043.08-.054a.285.285 0 0 1 .12-.043.45.45 0 0 1 .127-.004.198.198 0 0 1 .101.04l.087.055c.031.022.062.042.093.06a.33.33 0 0 0 .199.024c.018-.005.03.01.009.024-.148.108-.261.008-.358-.038.035.03.066.062.092.094a.52.52 0 0 0 .15.133.312.312 0 0 0 .224.044c.012-.002.017 0 .017.007 0 .006 0 .017-.008.023a.184.184 0 0 1-.114.04.376.376 0 0 1-.228-.077c-.059-.04-.098-.09-.144-.133a.308.308 0 0 0-.13-.08.548.548 0 0 0-.205.01.992.992 0 0 0-.165-.081.542.542 0 0 1 .053-.045Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m19.028 8.526-.034.077a.067.067 0 0 1-.053.04l-.069.008a.067.067 0 0 1-.055-.02l-.02-.02a.046.046 0 0 1 .012-.073l.14-.07a.067.067 0 0 0 .027-.025l.117-.187a.067.067 0 0 0-.057-.102h-.217a.067.067 0 0 0-.027.006l-.138.06a.066.066 0 0 0-.035.037l-.152.386a.067.067 0 0 1-.035.036l-.023.01a.067.067 0 0 1-.064-.005l-.018-.012a.044.044 0 0 1-.005-.071l.064-.055a.066.066 0 0 0 .022-.037l.08-.368a.03.03 0 0 0-.037-.034l-.016.004a.067.067 0 0 0-.044.04l-.081.21a.066.066 0 0 1-.006.01l-.058.093a.067.067 0 0 1-.082.026l-.034-.014a.044.044 0 0 1-.007-.078l.053-.033a.067.067 0 0 0 .027-.034l.094-.26a.067.067 0 0 0-.003-.052l-.067-.134a.067.067 0 0 1-.006-.043l.074-.362a.067.067 0 0 0-.005-.043l-.03-.06a.067.067 0 0 1 0-.058l.029-.061a.046.046 0 0 0-.05-.065l-.047.009a.067.067 0 0 1-.067-.028l-.012-.017a.067.067 0 0 1 .005-.082l.106-.122a.065.065 0 0 0 .015-.027l.008-.032a.067.067 0 0 1 .05-.048l.154-.034a.067.067 0 0 1 .036.003l.285.103a.042.042 0 0 1 .002.077l-.084.034a.067.067 0 0 1-.034.004l-.03-.004a.03.03 0 0 0-.032.039l.089.262a.067.067 0 0 0 .045.043l.903.246a.06.06 0 0 0 .03 0L20 7.556a.04.04 0 0 1 .043.021.029.029 0 0 1-.013.038h-.001l-.06.028a.067.067 0 0 0-.038.042l-.015.053a.066.066 0 0 1-.032.04l-.094.05a.067.067 0 0 0-.035.056l-.01.21a.068.068 0 0 1-.003.021l-.095.255a.067.067 0 0 1-.02.027l-.318.27a.067.067 0 0 0-.019.026l-.027.072a.067.067 0 0 1-.078.04l-.007-.001a.043.043 0 0 1-.025-.068l.038-.051a.064.064 0 0 0 .009-.016l.089-.24a.056.056 0 0 0-.09-.062l-.154.136a.067.067 0 0 0-.017.024Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10.475 9.69c-.488.178-1.039-.087-1.282-.597.321.286.757.396 1.156.25.399-.144.662-.51.724-.934.141.547-.11 1.104-.598 1.282Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m9.503 6.623.354.319.443-.157.02-.008-.004.022-.089.477.353.32.016.015-.02.007-.443.158-.09.477-.005.022-.016-.015-.354-.318-.443.156-.02.008.004-.022.09-.477-.353-.32-.017-.015.02-.007.443-.158.09-.477.005-.022.016.015Zm13.122.057.041.473.431.188.02.009-.018.013-.39.288.04.474.002.022-.02-.009-.432-.186-.391.287-.018.013-.002-.022-.041-.474-.431-.187-.02-.01.018-.012.39-.288-.04-.474-.002-.022.02.008.432.186.391-.286.018-.013.002.021Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "m11.312 6.96 3.11-.55.06.667-3.009.53-.162-.648Zm.318 1.276 2.91-.513.06.667-2.808.495-.162-.649Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagHrv = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagHrv_default = SvgFlagHrv;
export {
  FlagHrv_default as default
};
